import { Service, inject } from '@angular/core';
import { MessageService } from 'primeng/api';
import { SENTRY_TOKEN } from '@app/core/services/sentry/sentry.token';

/** Shared handler for failed data flows: reports to Sentry, logs, and shows a toast. */
@Service()
export class ErrorService {
  private readonly _messageService = inject(MessageService);
  private readonly _sentry = inject(SENTRY_TOKEN);

  // Reports the error to Sentry and the console, and shows the user an error toast.
  handleError(error: unknown, message: string): void {
    this._sentry.captureException(error);
    console.error(error);
    this._messageService.add({
      severity: 'error',
      summary: 'Error',
      detail: message,
    });
  }
}
